<script>
import i18n from "@/i18n";

export default {
  name: 'LanguageSelector',
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/italy.svg"),
          language: "it",
          title: "Italiano",
        },
        {
          flag: require("@/assets/images/flags/germany.svg"),
          language: "de",
          title: "Deutsche",
        },
        {
          flag: require("@/assets/images/flags/fr.svg"),
          language: "fr",
          title: "Français",
        },
        {
          flag: require("@/assets/images/flags/gb.svg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/spain.svg"),
          language: "es",
          title: "Español",
        },
        {
          flag: require("@/assets/images/flags/pt.svg"),
          language: "pt",
          title: "Portuguesa",
        },
        // {
        //   flag: require("@/assets/images/flags/russia.svg"),
        //   language: "ru",
        //   title: "русский",
        // },
        // {
        //   flag: require("@/assets/images/flags/china.svg"),
        //   language: "ch",
        //   title: "中國人",
        // },
        // {
        //   flag: require("@/assets/images/flags/ae.svg"),
        //   language: "ar",
        //   title: "Arabic",
        // },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,

    };
  },
  methods: {
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      document.getElementById("header-lang-img").setAttribute("src", flag);
      this.$changeLocale(locale);
    },
  },
  mounted() {
    console.log(`Locale this.lan ${this.lan}`);
    console.log(`Locale this.text ${this.text}`);
    console.log(`Locale this.flag ${this.flag}`);
    console.log(`Locale i18n.global.locale.value ${i18n.global.locale.value}`);
    console.log(`Locale navbar ${i18n.locale}`);
    if (process.env.VUE_APP_I18N_LOCALE) {
      this.flag = i18n.global.locale.value;
      this.languages.forEach((item) => {
        if (item.language == this.flag) {
          // Ensure the element exists before attempting to set its attribute
          const headerLangImg = document.getElementById("header-lang-img");
          if (headerLangImg) {
            headerLangImg.setAttribute("src", item.flag);
          } else {
            console.error('Element with ID "header-lang-img" was not found.');
          }
        }
      });
    }
  },
};
</script>

<template>
  <BDropdown class="dropdown" variant="ghost-secondary" dropstart :offset="{ alignmentAxis: 55, crossAxis: 15, mainAxis: -50 }"
             toggle-class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle arrow-none" menu-class="dropdown-menu-end">
    <template #button-content>
      <img id="header-lang-img" src="@/assets/images/flags/italy.svg" alt="Header Language" height="20" class="rounded">
    </template>
    <BLink href="javascript:void(0);" class="dropdown-item notify-item language py-2" v-for="(entry, key) in languages"
           :data-lang="entry.language" :title="entry.title" @click="setLanguage(entry.language, entry.title, entry.flag)" :key="key">
      <img :src="entry.flag" alt="user-image" class="me-2 rounded" height="18">
      <span class="align-middle">{{ entry.title }}</span>
    </BLink>
  </BDropdown>
</template>